import React from "react";
import data from "../json/Allproducts/Xpertproof.json";
import Section1 from "../components/Allproducts/Section1";
import Section4 from "../components/Allproducts/Section4";
import Section3 from "../components/Allproducts/Section3";
import SEO from "../components/SEO";

const xpertProofSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "XPERT PROOF",
  "brand": {
    "@type": "Brand",
    "name": "Transforma Pvt Ltd"
  },
  "logo": "https://www.transforma.in/images/transformalogo.svg",
  "description": "XPERT PROOF is a comprehensive correction management platform enabling editors and publishers to validate and approve author corrections with support for both offline PDF annotations and an online native LaTeX editor interface."
  
};

const Xpertproof = () => {
  return (
    <>
    <SEO
        title="XPERT PROOF | Author Correction & Proof Validation Platform"
        description="Empower editors and publishers with XPERT PROOF. Manage the correction process via online native LaTeX editing or offline Adobe PDF annotation, with instant PDF/EPUB generation and XML validation."
        keywords="XPERT PROOF, author correction platform, proof validation software, online LaTeX editor, PDF annotation tool, editorial proofreading system, content transformation, query tracking, publisher correction workflow, XML proofing generation"
        canonical="https://www.transforma.in/products/xpertproof" 
        schema={xpertProofSchema}
      />
    <div className="w-full flex flex-col items-center ruler">
      <Section1 data={data}/>
      <Section3 data={data.Section5}/>
      <Section4 data={data.Section4}/>
    </div>
    </>
  );
};

export default Xpertproof;
